module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/name/suffix.js
// module id = 1215
// module chunks = 0